import React from 'react';
import PropTypes from 'prop-types';
import ReviewDate from './ReviewDate';
import { Rating } from './Rating';
import { Source } from './Source';
import { ReviewContent } from './ReviewContent';
import { ReviewModal } from './ReviewModal';

export default class Review extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false
		};
	}

	openModal() {
		this.setState({
			showModal: true
		});
	}

	closeModal() {
		this.setState({
			showModal: false
		});
	}

	render() {
		const { source, rating, content, author, reviewDate } =
			this.props.review;
		const {
			singleSource,
			windowId,
			reviewTruncationLength,
			labels,
			fontSize,
			reviewDateFontSize,
			ratingStarFullFillColor
		} = this.props;
		const contentIsLongerThanMax =
			(content || '').length > reviewTruncationLength;

		return (
			<div className="review px-sm-6">
				<div className="row mb-3">
					<div className="author-image-wrap col-xs-3">
						<img
							src="/static/assets/images/ui/author-avatar.svg"
							className="h-100 w-100"
							aria-hidden="true"
							alt=""
						/>
					</div>
					<div className="rating-wrap col-xs-9">
						<div className="d-flex align-items-center flex-wrap overflow-hidden">
							<h4 className="m-0 mr-3">{author}</h4>
							{!singleSource && (
								<Source
									source={source}
									singleSource={singleSource}
								/>
							)}
						</div>
						<Rating
							rating={rating}
							source={source}
							labels={labels}
							fontSize={fontSize}
							ratingStarFullFillColor={ratingStarFullFillColor}
						/>
						<ReviewDate
							reviewDate={reviewDate}
							fontSize={reviewDateFontSize}
						/>
					</div>
				</div>
				<ReviewContent
					truncate
					fontSize={fontSize}
					content={content}
					openModal={() => this.openModal()}
					windowId={windowId}
					maxCharacters={reviewTruncationLength}
					seeFullReviewLabel={labels.get('SEE_FULL_REVIEW')}
				/>
				{contentIsLongerThanMax && (
					<ReviewModal
						show={this.state.showModal}
						closeModal={() => this.closeModal()}
						author={author}
						content={content}
						source={source}
						reviewDate={reviewDate}
						rating={rating}
						singleSource={singleSource}
						labels={labels}
						fontSize={fontSize}
						reviewDateFontSize={reviewDateFontSize}
					/>
				)}
			</div>
		);
	}
}

Review.propTypes = {
	review: PropTypes.shape({
		source: PropTypes.string.isRequired,
		author: PropTypes.string.isRequired,
		content: PropTypes.string.isRequired,
		rating: PropTypes.number.isRequired,
		reviewDate: PropTypes.string.isRequired
	}).isRequired,
	singleSource: PropTypes.bool.isRequired,
	windowId: PropTypes.string.isRequired,
	reviewTruncationLength: PropTypes.number.isRequired,
	labels: PropTypes.shape({
		get: PropTypes.func
	}).isRequired,
	fontSize: PropTypes.string,
	reviewDateFontSize: PropTypes.string,
	ratingStarFullFillColor: PropTypes.string
};

Review.defaultProps = {
	fontSize: '',
	reviewDateFontSize: ''
};
